import React from 'react'
import { connect } from 'react-redux'
import { PieChart, Pie, ResponsiveContainer, Cell } from 'recharts';
import moment from 'moment';


const RADIAN = Math.PI / 180;

const plafondEncours = [
    { name: 'A', value: 50, color: '#24b7bb' },
    { name: 'B', value: 25, color: '#006291' },
    { name: 'C', value: 25, color: '#001248' },
];

const needle = (value, cx, cy) => {
    let total = 0;

    const iR = 50;
    const oR = 100;

    plafondEncours.forEach((v) => {
        total += v.value;
    });
    const ang = 180.0 * (1 - value / total);
    const length = (iR + 2 * oR) / 3;
    const sin = Math.sin(-RADIAN * ang);
    const cos = Math.cos(-RADIAN * ang);
    const r = 5;
    const x0 = cx + 5;
    const y0 = cy + 5;
    const xba = x0 + r * sin;
    const yba = y0 - r * cos;
    const xbb = x0 - r * sin;
    const ybb = y0 + r * cos;
    const xp = x0 + length * cos;
    const yp = y0 + length * sin;

    return [
        <circle key={'circle' + value} id={value} cx={x0} cy={y0} r={r} fill={'#FFFFFF'} stroke="none" />,
        <path key={'path' + value} d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`} stroke="#none" fill={'#000000'} />,
    ];
};

class BlockPlafond extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.refContainer = React.createRef()


    }

    componentDidMount() {
        this.setState({
            cy: this.refContainer.current.current.clientHeight / 2,
            cx: this.refContainer.current.current.clientWidth / 2
        })

    }


    render() {

        const { cx } = this.state
        const cy = 120
        let totalEncours = 0
        let nbjourPlafond = 100;
        let today = moment().format('DD');


        if (this.props.url === 'btf') {
            totalEncours=this.props.encoursWex
        } else {
            this.props.encoursEnseigne.forEach(item => { totalEncours += item.value })
        }
        const consomoyenneJour = totalEncours / today

        if (consomoyenneJour !== 0) {
            nbjourPlafond = this.props.plafond === undefined || this.props.plafond === 0 || this.props.plafond < totalEncours ? 0 : Math.round(this.props.plafond / consomoyenneJour)

        }


        const datePlafond = moment().startOf('month').add(nbjourPlafond, 'days')

        const enCoursRation = this.props.plafond === undefined || this.props.plafond === 0 || this.props.plafond < totalEncours ? 100 : (totalEncours / this.props.plafond) * 100
        return (
            <div className='HomeBlock  graphic' >
                <p className='HomeBlockTitle'>- VOTRE CONSOMMATION EN COURS -</p>
                <p >PLAFOND MENSUEL*</p>
                <p className='HomeBlockTitle'>{Intl.NumberFormat().format(this.props.plafond)}€</p>
                <ResponsiveContainer ref={this.refContainer} width="100%" height={130}>
                    <PieChart>
                        <Pie
                            dataKey='value'
                            key='name'
                            startAngle={180}
                            endAngle={0}
                            data={plafondEncours}
                            cx={cx}
                            cy={cy}
                            innerRadius={60}
                            outerRadius={100}
                            fill="#8884d8"
                            stroke="none"
                        >
                            {plafondEncours.map((entry) => (
                                <Cell key={entry.name} fill={entry.color} />))
                            }
                        </Pie>
                        {needle(enCoursRation, cx, cy)}

                    </PieChart>
                </ResponsiveContainer>
                <p className='HomeBlockTitle'>{totalEncours.toFixed(2)}€</p>
                <p >Selon vos habitudes de consommation, </p>
                {moment().endOf('month').diff(datePlafond) < 0 ? <p>vous ne devriez pas atteindre votre plafond</p> : <p >votre plafond sera atteint le <b>{moment(datePlafond).format('DD/MM/YYYY')} </b></p>}
                <div style={{ position: 'relative', bottom: 0 }}><br /><p style={{ fontSize: 'small' }}>*Remise à 0 le 1er du mois suivant</p></div>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return ({
        contentHeight: state.app.contentHeight,
        encoursProduits: state.app.encoursProduits,
        encoursEnseigne: state.app.encoursEnseigne,
        encoursWex: state.app.encoursWex,
        nomCommercial: state.app.nomCommercial,
        telCommercial: state.app.telCommercial,
        plafond: state.app.plafond,
        emailCommercial: state.app.emailCommercial,
        url: state.app.url
    })
}


export default connect(mapStateToProps)(BlockPlafond)